import { render, staticRenderFns } from "./ChatBotCreateQuestion.vue?vue&type=template&id=63af6bee&scoped=true&"
import script from "./ChatBotCreateQuestion.vue?vue&type=script&lang=js&"
export * from "./ChatBotCreateQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ChatBotCreateQuestion.vue?vue&type=style&index=0&id=63af6bee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63af6bee",
  null
  
)

export default component.exports